var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.navigation !== false
    ? _c("div", { staticClass: "page-tools" }, [
        _vm.data.tools.print
          ? _c("div", { staticClass: "page-tools__item" }, [
              _c(
                "a",
                {
                  attrs: { href: "javascript: void(0);" },
                  on: {
                    click: function ($event) {
                      return _vm.print()
                    },
                  },
                },
                [
                  _c("z-icon", {
                    attrs: { name: "tools/print", width: "32", height: "32" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "page-tools__text" }, [
                    _vm._v(_vm._s(_vm.text.print)),
                  ]),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.data.tools.share
          ? _c(
              "div",
              { staticClass: "page-tools__item" },
              [
                _c(
                  "tippy-tooltip",
                  {
                    attrs: {
                      placement: "right",
                      trigger: _vm.getEventForDevice,
                      "append-to": "parent",
                      interactive: true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "trigger",
                          fn: function () {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "page-tools__link",
                                  attrs: { href: "javascript: void(0);" },
                                },
                                [
                                  _c("z-icon", {
                                    attrs: {
                                      name: "tools/share",
                                      color: "#c5c8cd",
                                      dir: "down",
                                      width: "33",
                                      height: "33",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "page-tools__text" },
                                    [_vm._v(_vm._s(_vm.text.share))]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3613565652
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c("z-share", {
                      attrs: {
                        services: ["facebook", "vkontakte", "twitter"],
                        lang: _vm.$root.lang,
                        bare: "",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }